<template>
  <div
    class="ms-text-area ms-editor flex"
    :class="{ error: errorProvider.isValid, disabled: disabled }"
  >
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
      <span
        v-if="isRequired"
        class="required"
      />
    </label>
    <div
      class="flex-row border"
      :class="{ error: errorMessage, disabled: disabled }"
    >
      <textarea
        ref="input"
        v-model="internalValue"
        class="ms-text-area-item flex"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
      <div
        v-if="errorMessage"
        class="icon24 error error-icon"
      />
    </div>
    <div
      v-if="errorMessage"
      class="error-text"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue'
import { useValidateControl } from '@/setup/validateControl.js'

import { UPDATE_MODEL_EVENT, INPUT_EVENT, CHANGE_EVENT, FOCUS_EVENT, BLUR_EVENT } from '@/components/utils/constants'

export default {
  name: 'MsTextArea',
  extends: msBaseComponent,
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
      type: String,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    // class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    // ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
  },
  emits: [UPDATE_MODEL_EVENT, FOCUS_EVENT, BLUR_EVENT],
  setup (props) {
    const {
      errorMessage,
      validate,
      getTitleError,
      clearValidate,
      isValidate,
      isRequired,
    } = useValidateControl({ props })

    const getValue = () => props.modelValue

    return {
      errorMessage,
      validate,
      getTitleError,
      clearValidate,
      isValidate,
      isRequired,
      getValue,
    }
  },
  computed: {
    listeners () {
      return {
        blur: (e) => {
          this.validate()
          this.$emit(FOCUS_EVENT)
        },
        focus: (e) => {
          this.$emit(BLUR_EVENT)
        },
        change: (e) => {
          this.$emit(CHANGE_EVENT, this.internalValue, e)
        },
        input: (e) => {
          this.$emit(INPUT_EVENT, this.internalValue, e)
        },
      }
    },
    internalValue: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit(UPDATE_MODEL_EVENT, val)
      },
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/components/MsTextArea.scss';
</style>
